const OCTOPUS_FAILED_EXPERIMENT_ID = '00000000-0000-0000-0000-000000000000';
const pushToDatalayer = (trackInfo) => {
    if (typeof window !== 'undefined') {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(trackInfo);
    }
};
const ASSIGNMENT_KEY_TO_TRACK_USER = {
    customerHash: 'visitorID',
    clientid: 'clientID',
};
export const trackError = (experiment, additionalPayload = {}) => {
    const experimentId = experiment.experimentId || OCTOPUS_FAILED_EXPERIMENT_ID;
    const trackingInfo = {
        event: 'TRACK_ABTESTING',
        octopus_variantResponse: `${experimentId}::default_variant::CLIENT::${experiment.error}`,
        ...additionalPayload,
    };
    pushToDatalayer(trackingInfo);
};
export const track = (experiment, additionalPayload = {}) => {
    const { variant, feedbackId, mode, id, assignmentKey, experimentId } = experiment;
    const trackingInfo = {
        event: 'TRACK_ABTESTING',
        octopus_testName: id,
        octopus_variantName: variant,
        octopus_feedbackID: feedbackId,
        octopus_mode: mode,
        octopus_variantResponse: `${experimentId}::${variant}::${mode}::`,
        ...(assignmentKey && {
            [ASSIGNMENT_KEY_TO_TRACK_USER[assignmentKey.key]]: assignmentKey.value,
        }),
        ...additionalPayload,
    };
    pushToDatalayer(trackingInfo);
};
//# sourceMappingURL=tracking.js.map